import React, { useState } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Navbar } from './components/Navbar';
import { Hero } from './components/Hero';
import { WhyGigi } from './components/WhyGigi';
import { HowItWorks } from './components/HowItWorks';
import { Pricing } from './components/Pricing';
import { Testimonials } from './components/Testimonials';
import { FAQ } from './components/FAQ';
import { Footer } from './components/Footer';
import { BetaSignup } from './components/BetaSignup';
import { TermsOfService } from './components/TermsOfService';
import { ContactUs } from './components/ContactUs';
import { DashboardLayout } from './components/dashboard/DashboardLayout';
import { AuthPage } from './components/auth/AuthPage';
import { PartnershipsPage } from './components/PartnershipsPage';
import { PitchDeck } from './components/PitchDeck';
import { InvestorLandingPage } from './components/investor/InvestorLandingPage';
const LandingPage = ({
  onJoinBeta,
  isBetaModalOpen,
  onCloseBeta,
  currentPage,
  setCurrentPage
}) => {
  if (currentPage === 'terms') {
    return <div className="min-h-screen bg-white" data-id="element-0">
        <Navbar onJoinBeta={onJoinBeta} showBackButton onBackClick={() => setCurrentPage('home')} data-id="element-1" />
        <TermsOfService data-id="element-2" />
        <Footer onTermsClick={() => setCurrentPage('terms')} onContactClick={() => setCurrentPage('contact')} data-id="element-3" />
        <BetaSignup isOpen={isBetaModalOpen} onClose={onCloseBeta} data-id="element-4" />
      </div>;
  }
  if (currentPage === 'contact') {
    return <div className="min-h-screen bg-white" data-id="element-5">
        <Navbar onJoinBeta={onJoinBeta} showBackButton onBackClick={() => setCurrentPage('home')} data-id="element-6" />
        <ContactUs data-id="element-7" />
        <Footer onTermsClick={() => setCurrentPage('terms')} onContactClick={() => setCurrentPage('contact')} data-id="element-8" />
        <BetaSignup isOpen={isBetaModalOpen} onClose={onCloseBeta} data-id="element-9" />
      </div>;
  }
  return <div className="min-h-screen bg-white" data-id="element-10">
      <Navbar onJoinBeta={onJoinBeta} data-id="element-11" />
      <main data-id="element-12">
        <Hero onJoinBeta={onJoinBeta} data-id="element-13" />
        <WhyGigi data-id="element-14" />
        <HowItWorks data-id="element-15" />
        <Pricing data-id="element-16" />
        <Testimonials data-id="element-17" />
        <FAQ data-id="element-18" />
      </main>
      <Footer onTermsClick={() => setCurrentPage('terms')} onContactClick={() => setCurrentPage('contact')} data-id="element-19" />
      <BetaSignup isOpen={isBetaModalOpen} onClose={onCloseBeta} data-id="element-20" />
    </div>;
};
export function App() {
  const [isBetaModalOpen, setIsBetaModalOpen] = useState(false);
  const [currentPage, setCurrentPage] = useState('home');
  return <BrowserRouter data-id="element-21">
      <Routes data-id="element-22">
        <Route path="/" element={<LandingPage onJoinBeta={() => setIsBetaModalOpen(true)} isBetaModalOpen={isBetaModalOpen} onCloseBeta={() => setIsBetaModalOpen(false)} currentPage={currentPage} setCurrentPage={setCurrentPage} data-id="element-24" />} data-id="element-23" />
        <Route path="/auth" element={<AuthPage data-id="element-26" />} data-id="element-25" />
        <Route path="/partnerships" element={<PartnershipsPage data-id="element-28" />} data-id="element-27" />
        <Route path="/deck" element={<PitchDeck data-id="element-30" />} data-id="element-29" />
        <Route path="/investors" element={<InvestorLandingPage data-id="element-32" />} data-id="element-31" />
        <Route path="/dashboard/*" element={<DashboardLayout data-id="element-34">
              <div className="text-2xl font-bold" data-id="element-35">
                Welcome to your Dashboard!
              </div>
            </DashboardLayout>} data-id="element-33" />
      </Routes>
    </BrowserRouter>;
}